$(document).ready(function(){
  // $('.faq-body .faq-inner-body:first').slideDown(350);
  // $('.faq-body .faq-content-description:first').addClass('active-accordian');
  $('.faq-body .faq-content-description').click(function(e) {
   e.preventDefault();
   let $this = $(this);
   if ($this.next().hasClass('show')) {
     $this.next().slideUp(350);
     $this.next().removeClass('show');
     $this.removeClass('active-accordian');
   } else {
     $this.parent().parent().find('.faq-inner-body').removeClass('show');
     $('.faq-body .faq-content-description').removeClass('active-accordian');
     $this.parent().parent().find('.faq-inner-body').slideUp(350);
     $this.next().toggleClass('show');
     $this.next().slideToggle(350);
     $this.toggleClass('active-accordian');
   }
  });

// var headerHeight = $('.header-wrapper').outerHeight();
  $('.faq-heading-main-left:first').addClass('faq-active-href');
  $('.faq-heading-main-left').click(function(e){
        e.preventDefault();        
        var targetId = $(this).attr('href');   
    
        $('.faq-heading-main-left').removeClass('faq-active-href');
        $(this).addClass('faq-active-href');
    
        $('html, body').animate({
            scrollTop: $(targetId).offset().top 
        }, 1000);
    }); 
  
 if ($(window).width() <= 767) { 
  $(".faq-wrapper-search-main").appendTo(".faq-wrapper-left"); 
 }

});


function myFunction() {
    var input, filter, faqContainers, i, j, h6, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    faqContainers = document.getElementsByClassName("faq-heading-both");
    for (i = 0; i < faqContainers.length; i++) {
        var faqBodies = faqContainers[i].getElementsByClassName("faq-body");

        for (j = 0; j < faqBodies.length; j++) {
            h6 = faqBodies[j].getElementsByTagName("div")[0];
            if (h6) {
                txtValue = h6.textContent || h6.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    faqBodies[j].style.display = "";
                } else {
                    faqBodies[j].style.display = "none";
                }
            }
        }       
        if (filter.trim() === "") {
            faqContainers[i].style.display = "";
        } else {
            var allHidden = Array.from(faqBodies).every(body => body.style.display === "none");
            if (allHidden) {
                faqContainers[i].style.display = "none";
            } else {
                faqContainers[i].style.display = "";
            }
        }
    }
}

